module.exports = __webpack_public_path__ + "img/layout_triangle_icon.0514cbf4.svg";